import React, { useEffect, useState, useContext } from "react";
import { useLocation,useHistory } from "react-router-dom";
import Repo from "../../Utility/Repo";
import ModalComponent from "../../Components/ModalComponent";
import Pagination from "../../Components/Pagination";
import iconSprite from "bootstrap-italia/dist/svg/sprite.svg";
import { TokenContext } from "../../Components/TokenContext";
import Loader from "../../Components/Loader";
import Badge from "../../Components/Badge";
import Icon from "../../Components/Icon";
import LabelsLoader from "../../Utility/labelsLoader";
import { Input } from "design-react-kit";

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

function ListFlows(props) {
  const apiToken = useContext(TokenContext);
  const [changeArray, setChangeArray] = useState(false);

  const [flows, setFlows] = useState();
  const [flowsTemp2, setFlowsTemp2] = useState();
  const [showFileToggle, toggleModalShowFile] = useState(false);
  const [flowsTemp, setFlowsTemp] = useState(null);
  const [file, setFile] = useState();
  const [loading, setLoading] = useState(true);
  const [servizi, setServizi] = useState([]);
  const [servizioTemp, setServizioTemp] = useState();
  const [isAlertVisible, setIsAlertVisible] = useState(false);
  const [isAlertErrorVisible, setIsAlertErrorVisible] = useState(false);
  let query = useQuery();

  const labels = LabelsLoader();

  const history = useHistory(); 

  const [filter, setFilter] = useState({
    stato: "",
    descrizione: query.get("descrizione") || "",
  });


  const handleFilterChange = (e) => {
    const newFilter = { ...filter, [e.target.name]: e.target.value };
    setFilter(newFilter);

    // Aggiorniamo la query string nell'URL
    const params = new URLSearchParams();
    if (newFilter.descrizione) params.set("descrizione", newFilter.descrizione);
    
    history.push({ search: params.toString() }); // Al posto di navigate()
  };

  const sendFilterClear = () =>{
    setFilter({
      stato: "",
      descrizione: "",
    });
 // Aggiorniamo la query string nell'URL
 const params = new URLSearchParams();
 params.set("descrizione", "");
 
 history.push({ search: params.toString() }); // Al posto di navigate()
  }



  useEffect(() => {
    if (apiToken) {
      setLoading(true);
      Promise.all([
        Repo.postListFlows(apiToken, JSON.stringify(filter)),
        Repo.getListaServizi(apiToken),
      ])
        .then(([flowsResponse, serviziResponse]) => {
          if (flowsResponse.status === 200) {
            setFlowsTemp(flowsResponse.data);
          }
          setServizi(serviziResponse.data);
        })
        .catch((error) => {
          console.error(error);
        })
        .finally(() => {
          setLoading(false);
        });
    }
  }, []);

  const sendFilter = () => {
    if (apiToken) {
      setLoading(true);
      Promise.all([
        Repo.postListFlows(apiToken, JSON.stringify(filter)),
        Repo.getListaServizi(apiToken),
      ])
        .then(([flowsResponse, serviziResponse]) => {
          if (flowsResponse.status === 200) {
            setFlowsTemp(flowsResponse.data);
          }
          setServizi(serviziResponse.data);
        })
        .catch((error) => {
          console.error(error);
        })
        .finally(() => {
          setLoading(false);
        });
    }
  };

  const [expandedRows, setExpandedRows] = useState({});

  const toggleRow = (id) => {
    setExpandedRows((prev) => ({
      ...prev,
      [id]: !prev[id], // Inverte lo stato della riga specifica
    }));
  };

  const filterSessions = (e) => {
    if (e) {
      setChangeArray(true);
      setServizioTemp(e.name);

      var arr = flowsTemp.filter(function (obj) {
        return obj.announcement.service.id.toUpperCase() == e.value;
      });

      setFlowsTemp2(arr);
    } else {
      setChangeArray(false);
      setServizioTemp();
    }
  };

  const bodyFile = () => {
    return (
      <object
        width="100%"
        height="900"
        data={file && file.data}
        type={file && file.type}
      ></object>
    );
  };

  const elaborateFlows = (id) => {
    setLoading(false);
    Repo.ValidateCSVByToken(apiToken, id)
      .then((response) => {
        if (response.status == 200) {
          setLoading(true);
          setIsAlertVisible(true);
          window.location.reload(false);
        }
      })
      .catch((error) => {
        console.log(error);
        setLoading(true);
        setIsAlertErrorVisible(true);
      });
  };

  const InviaFlussoEmail = (id) => {
    setLoading(false);
    Repo.InviaFlussoEmail(apiToken, id)
      .then((response) => {
        if (response.status == 200) {
          setLoading(true);
          setIsAlertVisible(true);
          window.location.reload(false);
        }
      })
      .catch((error) => {
        console.log(error);
        setLoading(true);
        setIsAlertErrorVisible(true);
      });
  };

  useEffect(() => {
    if (filter != null) {
      const timer = setTimeout(() => {
        setIsAlertVisible(false);
      }, 4000);
      return () => clearTimeout(timer);
    }
  }, [isAlertVisible]);

  function getStatoImport(currentStato = "") {
    switch (currentStato) {
      case "IMPORT_ESEGUITO":
        return <Badge badgeText="Flusso approvato" badgeStatus="bg-success" />;
      case "LOAD_IMPORT":
        return <Badge badgeText="Flusso caricato" badgeStatus="bg-warning" />;
        case "IMPORT_IN_ELAB":
          return <Badge badgeText="In elaborazione..." badgeStatus="bg-warning" />;
      case "IMPORT_ERROR_SL":
        return (
          <Badge badgeText="Errore flusso interno" badgeStatus="bg-danger" />
        );
      default:
        return <Badge badgeText="Errore flusso" badgeStatus="bg-danger" />;
    }
  }

  function badgeEmail(isEmailSent) {
    if (isEmailSent) {
      return <Badge badgeText="Email inviata" badgeStatus="bg-success" />;
    } else {
      return <Badge badgeText="Email da inviare" badgeStatus="bg-danger" />;
    }
  }

  function getStatoFile(currentStato = false) {
    switch (currentStato) {
      case true:
        return (
          <Icon
            text="Scarica file valido"
            icon="it-check-circle"
            status="icon-success"
            spanText="Scarica file valido"
          />
        );
      default:
        return (
          <Icon
            text="Scarica file scaduto"
            icon="it-warning-circle"
            status="icon-warning"
            spanText="Scarica file scaduto"
          />
        );
    }
  }

  const expandedRow = (x) => {
    return (
      <>
        <div
          className="collapse accordion-collapse"
          id={"collapseExample_" + x.id}
          data-parent={"#collapseExample_" + x.id}
        >
          <div className="row">
            <div className="col-lg-10 d-flex my-4  justify-content-end">
              {" "}
              {x.urlFileAvvisi ? (
                <>
                  <a className=" " href={x.urlFileAvvisi}>
                    Avvisi
                  </a>
                </>
              ) : (
                <>
                  <a
                    className="text-decoration-none"
                    href={x.urlFileAvvisi}
                    data-bs-toggle="tooltip"
                    data-bs-placement="bottom"
                    title="Nessun link presente"
                  >
                    Avvisi
                  </a>
                </>
              )}
            </div>
            <div className="col-lg-0 mr-1 ml-1 my-4">
              {" "}
              {x.urlFileIUV ? (
                <>
                  <a href={x.urlFileIUV}>
                    | <u>IUV</u> |
                  </a>
                </>
              ) : (
                <>
                  {" "}
                  <a
                    className="text-decoration-none"
                    href={x.urlFileIUV}
                    data-bs-toggle="tooltip"
                    data-bs-placement="bottom"
                    title="Nessun link presente"
                  >
                    | IUV |
                  </a>
                </>
              )}
            </div>
            <div className="col-lg-0 my-4 mr-5">
              {x.urlFileScarti ? (
                <>
                  <a className="ml-1" href={x.urlFileScarti}>
                    Scartati
                  </a>
                </>
              ) : (
                <>
                  {" "}
                  <a
                    className="ml-1 text-decoration-none"
                    href={x.urlFileScarti}
                    data-bs-toggle="tooltip"
                    data-bs-placement="bottom"
                    title="Nessun link presente"
                  >
                    Scartati
                  </a>
                </>
              )}
            </div>
          </div>
        </div>
      </>
    );
  };

return flowsTemp !== undefined ? (
    <>


      <div className="row mb-2">
        <div className="col-10">
          <h1>
            <b>{labels.flussimypay}</b>
          </h1>
        </div>
        <div className="clearfix col-lg-8 py-lg-2 mb-3">
          <p>{labels.tuttiflussi}</p>
        </div>
      </div>



      <div className="mt-3 shadow-sm p-3 mb-5 bg-white rounded">
      <div className="row">
        <div className="form-group col-4">
          <Input
            id="descrizione"
            required
            label="Ricerca nel titolo"
            type="text"
            name="descrizione"
            value={filter.descrizione}
            onChange={handleFilterChange}
          />
        </div>

        
        <div className="form-group col-4">
          stato
         </div>

        <div className="form-group col-4 text-right">
          <button type="button" 
          onClick={sendFilterClear}
          className="btn btn-outline-secondary m-2">
            Annulla
          </button>
          
          <button
            type="button"
            className="btn btn-outline-primary"
            onClick={sendFilter}
          >
            Cerca
          </button>
        </div>
      </div>
      </div>



      <div className=" col-lg-12">
        <div className=" no-after">
          <div className="">
            {flows && flows.length > 0 ? (
              flows.map((x, index) => (
                <React.Fragment key={x.id}>
                  <div className="row">
                    <div className="col-lg-8">
                      <span className="badge rounded-pill bg-primary text-white">
                        {x.dataInsert}
                      </span>
                      {getStatoImport(x.stato)}
                      {badgeEmail(x.isEmailSent)}
                      <br />
                      {x.announcement && x.announcement.service.name}
                      <strong>
                        <strong> ( {x.announcement && x.num} ) </strong>
                      </strong>
                      : {x.announcement && x.announcement.name}
                    </div>

                    <div className="col-lg-2 d-flex align-items-center gap-2">
                      <div>{getStatoFile(x.available)}</div>
                      <div>
                        <button
                          className={`btn btn-outline-primary btn-xs ${
                            x.isEmailSent ? "text-secondary" : "text-primary"
                          }`}
                          data-bs-toggle="tooltip"
                          data-bs-placement="bottom"
                          title={
                            x.isEmailSent
                              ? "Reinvia email per tutti i bollettini"
                              : "Invia email per tutti i bollettini"
                          }
                          //   disabled =  {(x.isEmailSent) ? true  : false}
                          onClick={() => InviaFlussoEmail(x.id)}
                        >
                          {" "}
                          <svg
                            className={`icon icon-sm ${
                              x.isEmailSent ? "icon-secondary" : "icon-primary"
                            }`}
                          >
                            <use xlinkHref={`${iconSprite}#it-mail`}></use>
                          </svg>
                          &nbsp;
                          {x.isEmailSent ? "Reinvia email" : "Invia email"}
                        </button>
                      </div>
                    </div>

                    <div className="col-lg-2 d-flex align-items-center gap-2">
                      <button
                        className="btn btn-outline-primary btn-xs"
                        data-bs-toggle="tooltip"
                        data-bs-placement="bottom"
                        title="Rielabora"
                        onClick={() => elaborateFlows(x.requestToken)}
                      >
                        {" "}
                        <svg className="icon icon-sm icon-primary">
                          <use xlinkHref={`${iconSprite}#it-restore`}></use>
                        </svg>
                        &nbsp; Rielabora
                      </button>

                      <button
                        type="button"
                        className="btn rounded btn-xs"
                        data-toggle="collapse"
                        href={"#collapseExample_" + x.id}
                        role="button"
                        aria-expanded="false"
                        aria-controls={"collapseExample_" + x.id}
                        data-bs-toggle="tooltip"
                        data-bs-placement="bottom"
                        title={
                          !x.available ? "Rielabora per espandere" : "Espandi"
                        }
                        disabled={!x.available ? true : false}
                      >
                        <svg className="icon icon-primary">
                          <use
                            xlinkHref={`${iconSprite}#${
                              expandedRows[x.id] ? "it-collapse" : "it-expand"
                            }`}
                          ></use>
                        </svg>
                      </button>
                    </div>
                  </div>
                  {expandedRow(x)}

                  <hr></hr>
                </React.Fragment>
              ))
            ) : (
              <div>Non sono presenti flussi per il servizio selezionato</div>
            )}

            {flowsTemp &&
              (changeArray == false ? (
                <Pagination
                  key={flowsTemp + changeArray}
                  items={flowsTemp}
                  setCurrentItems={setFlows}
                  itemsPerPage={100}
                ></Pagination>
              ) : (
                <Pagination
                  key={flowsTemp2 + changeArray}
                  items={flowsTemp2}
                  setCurrentItems={setFlows}
                  itemsPerPage={100}
                ></Pagination>
              ))}
          </div>
        </div>
      </div>

      <ModalComponent
        toggleModal={() => toggleModalShowFile(!showFileToggle)}
        isOpen={showFileToggle}
        header={"File"}
        body={bodyFile()}
        buttonDeny="Chiudi"
      ></ModalComponent>

      {isAlertVisible && (
        <>
          <div
            className="alert alert-success"
            role="alert"
            style={{
              position: "fixed",
              bottom: 0,
              right: "15px",
              backgroundColor: "#fff",
              width: "22%",
              zIndex: 10000,
            }}
          >
            <b>Rielaborazione avvenuta con successo.</b>
          </div>
        </>
      )}

      {isAlertErrorVisible && (
        <>
          <div
            className="alert alert-danger"
            role="alert"
            style={{
              position: "fixed",
              bottom: 0,
              right: "15px",
              backgroundColor: "#fff",
              width: "22%",
              zIndex: 10000,
            }}
          >
            <b>Errore nella rielaborazione, riprova.</b>
          </div>
        </>
      )}
    </>
  ) : (
    <div>{loading && <Loader />}</div>
  );
}

export default ListFlows;
